import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_TIPOS_ACTIVIDADES_EXTRACUR = 'ALL_TIPOS_ACTIVIDADES_EXTRACUR';
export const LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR =
  'LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR';
export const ACTIVO_TIPOS_ACTIVIDADES_EXTRACUR =
  'ACTIVO_TIPOS_ACTIVIDADES_EXTRACUR';
export const PARAMS_TIPOS_ACTIVIDADES_EXTRACUR =
  'PARAMS_TIPOS_ACTIVIDADES_EXTRACUR';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const tiposActividadesExtcurReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_TIPOS_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        all: action.payload.data,
        meta: action.payload.meta,
      };
    case LOADING_ALL_TIPOS_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_TIPOS_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_TIPOS_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
